import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from '@/utils/toast';
import secureApi from './secureApi';

const validatePhone = async (phone: string) => {
  try {
    const res = await secureApi('/verify-phone', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ phone }),
    });
    const resData = await res.json();
    return resData?.responseObject?.Result?.ValidationResult.toLowerCase() === 'valid';
  } catch (error: any) {
    toast.error(error?.message || 'Error validating phone!');
    return false;
  }
};

const useValidatePhone = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: validatePhone,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['validate-phone'] }); // Refetch after mutation
    },
  });
};

export default useValidatePhone;
